export default __webpack_public_path__ + "static/media/knowledge-hub-bg.50c79990.jpg";